import { useEffect, useState } from 'react'

import paymentEvents from '@/utils/gaEvents/paymentEvents'

import Shared from '@/shared'

export interface PurchaseCarNumViewModel {
  texts: object
  states: {
    carNum: string
  }
  setters: object
  handlers: {
    validateCarNum: (carNum: string) => boolean
    handleCarNumNextBtn: () => void
    onClickHeaderBackBtn: () => void
    onChangeCarNumValue: (e: React.ChangeEvent<HTMLInputElement>) => void
  }
}

export interface usePurchaseCarNumViewModelProps {
  isPartner: boolean
}

const usePurchaseCarNumViewModel = ({ isPartner }: usePurchaseCarNumViewModelProps): PurchaseCarNumViewModel => {
  const setStep = Shared.States.usePurchaseStep((state) => state.setPurchaseStep)
  const { carnum } = Shared.States.useStorageStore()
  const [carNum, setCarNum] = useState('')
  const handleCarNumNextBtn = () => {
    if (isPartner) {
      paymentEvents.partner.onLoadCarNum()
    } else {
      paymentEvents.shared.onLoadCarNum()
    }
    setStep(3)
  }

  useEffect(() => {
    if (carnum.length > 0) {
      setCarNum(carnum)
    }
  }, [])

  const validateCarNum = (carNum: string) => {
    const carNumCheck =
      /^[0-9]{2,3}[가-힣]{1}[0-9]{4}$/gm.test(carNum) || /^[가-힣]{2}[0-9]{2}[가-힣]{1}[0-9]{4}$/gm.test(carNum)
    return carNumCheck
  }

  const onChangeCarNumValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCarNum(e.target.value)
  }

  const onClickHeaderBackBtn = () => {
    setStep(1)
  }
  return {
    texts: {},
    states: {
      carNum
    },
    setters: {},
    handlers: {
      validateCarNum,
      handleCarNumNextBtn,
      onClickHeaderBackBtn,
      onChangeCarNumValue
    }
  }
}

export default usePurchaseCarNumViewModel
